function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M0 0H16V16H0z",
  transform: "translate(-38.000000, -161.000000) translate(24.000000, 89.000000) translate(10.000000, 15.000000) translate(4.000000, 4.000000) translate(0.000000, 53.000000)"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#304FFE",
  fillRule: "nonzero",
  d: "M8 1C4.85 1 2 3.415 2 7.15c0 2.385 1.837 5.19 5.505 8.422.285.248.712.248.997 0C12.162 12.34 14 9.535 14 7.15 14 3.415 11.15 1 8 1zm0 8.6C6.57 9.6 5.4 8.43 5.4 7c0-1.43 1.17-2.6 2.6-2.6 1.43 0 2.6 1.17 2.6 2.6 0 1.43-1.17 2.6-2.6 2.6z",
  transform: "translate(-38.000000, -161.000000) translate(24.000000, 89.000000) translate(10.000000, 15.000000) translate(4.000000, 4.000000) translate(0.000000, 53.000000)"
}))))));
function SvgDestinationPoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDestinationPoint);
export default __webpack_public_path__ + "static/media/destination-point.8806979026000ab121dbc1a5db2ac36f.svg";
export { ForwardRef as ReactComponent };